import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage, PromiseRetry} from '../../../lib/components';
import {promiseStates, ReactNodeGenerator} from '../../../lib/helpers';
import {StudentClassroomSceneStore} from '../student/StudentClassroomSceneStore';
import {TeacherClassroomSceneStore} from '../teacher/TeacherClassroomSceneStore';

const ps = promiseStates;

function* renderer(store: StudentClassroomSceneStore | TeacherClassroomSceneStore): ReactNodeGenerator {
  const loader = store.classroomLoader;

  yield (<PromiseMessage key="classroom-load-message"
                         state={loader}
                         label="Loading classroom"
                         align="center"/>);

  yield (<PromiseRetry key="classroom-load-retry"
                       state={loader}
                       retry={store.loadClassroom}
                       align="center"/>);


  if (ps.isResolved(loader) && loader.value.Status !== 'InProgress') {
    yield (
      <div className="row justify-content-center" key="classroom-not-in-progress">
        <div className="col-auto">
          <div className="alert alert-danger">
            Classroom is not in progress.
          </div>
          <div className="d-none">
            {loader.value.Status}
          </div>
        </div>
      </div>);
  }

  const dontReconnectMessage = store.hubStore.connection.dontReconnectMessage;
  if (dontReconnectMessage !== null) {
    yield (
      <div className="row justify-content-center" key="dont-reconnect-message">
        <div className="col-auto">
          <div className="alert alert-danger">
            {dontReconnectMessage}
          </div>
        </div>
      </div>);
  }
}

@observer
export class ClassroomLoaderControls extends React.Component<{
  store: StudentClassroomSceneStore | TeacherClassroomSceneStore
}> {
  render() {
    return Array.from(renderer(this.props.store));
  }
}
